// @ts-ignore
import * as React from "react";
import { Button, Modal } from "react-ui";

import { ModalText } from "../Styles/Modals.styles";
import { CombineFufResult } from "../../../../../../../../Common/CandyApiClient/Types/DraftActions/CombineFufResult";

import { TextBody } from "./MergeResult.styles";

interface MergeResultProps {
    mergeResult?: CombineFufResult;
    documentName?: string;
}

export const MergeResult = ({ mergeResult, documentName = "документов" }: MergeResultProps) => (
    <ModalText data-tid={"UploadInfo"}>
        <span data-tid={"Added"}>
            Количество добавленных {documentName}: {mergeResult?.addedItemsCount}
        </span>
        <br />
        <span data-tid={"Updated"}>
            Количество обновленных {documentName}: {mergeResult?.updatedItemsCount}
        </span>
    </ModalText>
);

export interface MergeResultModalProps extends MergeResultProps {
    headerText?: string;
    onClose: () => void;
}

export const MergeResultModal = (props: MergeResultModalProps) => (
    <Modal ignoreBackgroundClick={true} onClose={props.onClose}>
        <Modal.Header>{props.headerText ?? "Результат импорта"}</Modal.Header>
        <Modal.Body>
            <TextBody>
                <MergeResult mergeResult={props.mergeResult} documentName={props.documentName} />
            </TextBody>
        </Modal.Body>
        <Modal.Footer panel>
            <Button data-tid={"CloseMergeResult"} size={"medium"} onClick={props.onClose}>
                Закрыть
            </Button>
        </Modal.Footer>
    </Modal>
);
